import { Component } from '@angular/core'
import { EnvService } from '@envs/env-service'
import { FolderOverviewService } from '../store/services'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'folder-overview-details',
  templateUrl: './folder-overview-details.component.html',
  styleUrls: ['./folder-overview-details.component.scss'],
})
export class FolderOverviewDetailsComponent {
  get id(): number {
    return this.folderOverviewService.folderId
  }

  constructor(
    private envService: EnvService,
    private titleService: Title,
    private folderOverviewService: FolderOverviewService
  ) {
    this.titleService.setTitle('Folder Overview | Details')
  }

  public get baseJsUrl(): string {
    return `${this.envService.baseJsUrl}/folder-overview/${this.id}/sow-update-details?sow_id=${this.id}`
  }
}
